/**
 * Rotulos de data e hora das telas publicas.
 *
 * Existe como arquivo proprio para nao repetir o formatador entre a vitrine do
 * perfil e o resumo do wizard: a mesma data precisa ser escrita igual nos dois.
 */

/** "qui., 11 de set." — dia da semana, dia e mes abreviados. */
export function formatPublicDateLabel(value: string): string {
  if (!value) return "Data não selecionada";
  try {
    return new Date(`${value}T00:00:00`).toLocaleDateString("pt-BR", {
      weekday: "short",
      day: "2-digit",
      month: "short",
    });
  } catch {
    return value;
  }
}

/** Data local de um instante, em YYYY-MM-DD. */
export function toLocalYMD(now: Date = new Date()): string {
  const offset = now.getTimezoneOffset();
  return new Date(now.getTime() - offset * 60 * 1000).toISOString().slice(0, 10);
}

export function isTodayYMD(value: string, now: Date = new Date()): boolean {
  return String(value || "") === toLocalYMD(now);
}

/** "HH:MM" do relogio local, para comparar com horarios da agenda. */
export function currentClockLabel(now: Date = new Date()): string {
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
}

/**
 * Horarios ainda uteis de uma data: no dia corrente descarta os que ja
 * passaram; nos dias seguintes mantem todos. Ordena e limita a `limit`.
 */
export function resolveUpcomingTimes(
  date: string,
  times: string[],
  options: { limit?: number; now?: Date } = {}
): string[] {
  const { limit = 8, now = new Date() } = options;
  const sorted = [...new Set(times.filter(Boolean))].sort();
  if (!isTodayYMD(date, now)) return sorted.slice(0, limit);

  const clock = currentClockLabel(now);
  return sorted.filter((time) => time > clock).slice(0, limit);
}
